/**
 * `FieldValidationError` serves as a base error
 * that contains `fieldName` and error `message`
 * and that can be extended for specific use-cases,
 * like async validation of form fields.
 */
export class FieldValidationError extends Error {
  fieldName: string
  isFieldValidationError = true

  constructor({ fieldName, message }: { fieldName: string; message?: string }) {
    super(message)
    this.name = 'FieldValidationError'
    this.fieldName = fieldName
    // make `message` property enumerable, since `react-hook-form` is using object
    // spread operator on `setError` argument and it omits non-enumerable properties
    Object.defineProperty(this, 'message', { value: message, enumerable: true })
  }
}
